import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { saveNewDonation } from '../firebase/donationService';

// Array of inspirational quotes has been removed

// Styled components for the modal
const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  padding: 1rem;
  backdrop-filter: blur(4px);
  @media (max-width: 768px) {
    align-items: center;
    padding: 0.5rem;
  }
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 340px;
  max-height: 95vh;
  min-height: 60vh;
  overflow-y: auto;
  position: relative;
  animation: modalFadeIn 0.3s ease-out;
  margin-top: 0;
  @media (max-width: 768px) {
    max-width: 98vw;
    max-height: 98vh;
    min-height: 80vh;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  @media (max-width: 480px) {
    max-width: 100vw;
    max-height: 100vh;
    min-height: 90vh;
    border-radius: 0.5rem;
    margin: 0;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem 0.25rem 0.75rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 5;
  @media (max-width: 768px) {
    padding: 0.35rem 0.5rem 0.15rem 0.5rem;
  }
`;

const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--primary);
  margin: 0;
  line-height: 1.1;
  @media (max-width: 768px) {
    font-size: 1.1rem;
    max-width: 80%;
    line-height: 1.1;
  }
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #374151;
  padding: 0.35rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  &:hover {
    background-color: #f3f4f6;
    color: #1f2937;
  }
  svg {
    width: 1.1rem;
    height: 1.1rem;
  }
  @media (max-width: 768px) {
    padding: 0.35rem;
    svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

const ModalBody = styled.div`
  padding: 0.5rem 0.5rem 0.15rem 0.5rem;
  @media (max-width: 768px) {
    padding: 0.3rem 0.2rem 0.1rem 0.2rem;
  }
  @media (max-width: 480px) {
    padding: 0.1rem 0.05rem 0.05rem 0.05rem;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 0.65rem;
  position: relative;
`;

const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.2rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.87rem;
  letter-spacing: 0.2px;
  &::after {
    content: ' *';
    color: var(--accent);
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 0.55rem 0.7rem;
  border-radius: 0.4rem;
  border: 1px solid #e5e7eb;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  &::placeholder {
    color: #9ca3af;
    font-weight: 400;
  }
  &:hover {
    border-color: #d1d5db;
    background-color: #fff;
  }
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(35, 160, 73, 0.12);
    background-color: #fff;
  }
`;

const AmountInput = styled(Input)`
  margin-top: 0.5rem;
  margin-bottom: 0.7rem;
`;

const InlineErrorMessage = styled.div`
  color: #dc2626;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  
  &::before {
    content: '⚠️';
    font-size: 0.75rem;
  }
`;

const AmountButton = styled.button<{ $active: boolean }>`
  padding: 0.45rem 0.3rem;
  border-radius: 0.5rem;
  border: ${(props) => props.$active ? '2px solid var(--primary)' : '1px solid #e5e7eb'};
  background-color: ${(props) => props.$active ? 'rgba(35, 160, 73, 0.1)' : 'white'};
  font-weight: ${(props) => props.$active ? '700' : '500'};
  color: ${(props) => props.$active ? 'var(--primary)' : '#374151'};
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  box-shadow: ${(props) => props.$active ? '0 3px 6px rgba(0, 128, 0, 0.1)' : '0 1px 2px rgba(0, 0, 0, 0.05)'};
  position: relative;
  overflow: hidden;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${(props) => props.$active ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0))' : 'linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0))'};
  }
  &:hover {
    border-color: var(--primary);
    color: var(--primary);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 128, 0, 0.1);
  }
  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 128, 0, 0.1);
  }
`;


const AmountContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.45rem;
  margin-bottom: 0.7rem;
  position: relative;
  @media (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
  &::after {
    content: '';
    position: absolute;
    bottom: -0.4rem;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 2px;
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 2px;
  }
`;


const RadioGroup = styled.div`
  display: flex;
  gap: 0.7rem;
  margin-top: 0.2rem;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.87rem;
  color: #374151;
  cursor: pointer;
  padding: 0.25rem 0.4rem;
  border-radius: 0.35rem;
  transition: all 0.2s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
  input {
    cursor: pointer;
    width: 0.95rem;
    height: 0.95rem;
    accent-color: var(--primary);
  }
`;


const RadioInput = styled.input`
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  transition: all 0.2s;
  
  &:checked {
    border-color: var(--primary);
    background-color: white;
  }
  
  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background-color: var(--primary);
  }
`;

// Quote-related styled components have been removed

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.25rem;
  margin-top: 1.5rem;
  position: relative;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: -0.75rem;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 2px;
    background-color: var(--accent);
    z-index: 0;
    opacity: 0.5;
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const PrimaryButton = styled.button`
  padding: 0.55rem 0.5rem;
  font-weight: 600;
  border-radius: 0.35rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  width: 100%;
  font-size: 0.98rem;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.07);
  position: relative;
  overflow: hidden;
  background-color: var(--primary);
  color: white;
  min-height: 36px;
  @media (max-width: 480px) {
    font-size: 0.92rem;
    padding: 0.45rem 0.3rem;
    min-height: 32px;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  &:hover::after {
    opacity: 1;
  }
  &:active {
    transform: translateY(2px);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }
`;


const SecondaryButton = styled.button`
  padding: 0.55rem 0.5rem;
  font-weight: 600;
  border-radius: 0.35rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  width: 100%;
  font-size: 0.98rem;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.07);
  position: relative;
  overflow: hidden;
  background-color: white;
  color: var(--primary);
  border: 1px solid #e5e7eb;
  min-height: 36px;
  @media (max-width: 480px) {
    font-size: 0.92rem;
    padding: 0.45rem 0.3rem;
    min-height: 32px;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  &:hover::after {
    opacity: 1;
  }
  &:hover {
    border-color: var(--primary);
    background-color: rgba(0, 0, 0, 0.02);
  }
  &:active {
    transform: translateY(2px);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const SuccessIcon = styled.div`
  width: 4rem;
  height: 4rem;
  background-color: #d1fae5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  
  svg {
    width: 2rem;
    height: 2rem;
    color: #059669;
  }
`;

const SuccessTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.75rem;
`;

const SuccessMessage = styled.p`
  color: #4b5563;
  margin-bottom: 1.5rem;
`;

const InfoBox = styled.div`
  background-color: #f9fafb;
  border-radius: 0.5rem;
  padding: 1.25rem;
  margin: 1.5rem 0;
  border: 1px solid #e5e7eb;
`;

const InfoBoxTitle = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.75rem;
  text-align: left;
`;

const InfoBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
  
  p {
    font-size: 0.875rem;
    color: #4b5563;
    text-align: left;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const CopyIcon = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: var(--primary);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const CopyToast = styled.div<{ visible: boolean }>`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1f2937;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  opacity: ${props => props.visible ? 1 : 0};
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 100;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

interface DonationModalProps {
  onClose: () => void;
}

const DonationModal: React.FC<DonationModalProps> = ({ onClose }) => {
  // Form state
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [amount, setAmount] = useState('1000'); // Default to 1,000 rupees
  const [isRecurring, setIsRecurring] = useState(true); // Default to monthly recurring
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  
  // Toast notification states
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  
  // State to toggle fund transfer details visibility
  const [detailsVisible, setDetailsVisible] = useState(false);
  
  // Field-specific error states
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [amountError, setAmountError] = useState('');
  
  // Function to copy text to clipboard and show toast notification
  const handleCopy = (text: string, fieldName: string) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setToastMessage(`${fieldName} copied to clipboard`);
        setToastVisible(true);
        setTimeout(() => setToastVisible(false), 2000);
      })
      .catch(err => {
        console.error('Could not copy text: ', err);
        setToastMessage('Failed to copy. Please try again.');
        setToastVisible(true);
        setTimeout(() => setToastVisible(false), 2000);
      });
  };
  
  // Function to copy all fund transfer details at once
  const handleCopyAllDetails = () => {
    const allDetails = `Fund Transfer Details:\n\n` +
      `UPI ID: youthekmjila@okicici\n` +
      `Gpay: 9037437401 (Youthekm Jila)\n` +
      `Bank Account: YOOSUF ALI K & AMJAD C V\n` +
      `A/C No: 7699652610\n` +
      `IFSC: IDIB000K726`;
      
    navigator.clipboard.writeText(allDetails)
      .then(() => {
        setToastMessage('All fund transfer details copied to clipboard');
        setToastVisible(true);
        setTimeout(() => setToastVisible(false), 2000);
      })
      .catch(err => {
        console.error('Could not copy text: ', err);
        setToastMessage('Failed to copy. Please try again.');
        setToastVisible(true);
        setTimeout(() => setToastVisible(false), 2000);
      });
  };

  // Quote-related code has been removed

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Reset all error states
    setNameError('');
    setPhoneError('');
    setAmountError('');
    
    let hasError = false;

    if (!name) {
      setNameError('Please enter your name');
      hasError = true;
    }
    
    if (!phone) {
      setPhoneError('Please enter your phone number');
      hasError = true;
    } else {
      // Basic validation - just ensure it has some numbers
      // This allows for international formats with country codes
      const phoneRegex = /[0-9]/;
      if (!phoneRegex.test(phone)) {
        setPhoneError('Please enter a valid phone number');
        hasError = true;
      }
    }
    
    if (!amount) {
      setAmountError('Please select or enter a donation amount');
      hasError = true;
    }
    
    if (hasError) {
      return;
    }

    try {
      console.log('Starting donation submission process...');
      setIsProcessing(true);

      // Create donation object
      const donationData = {
        name,
        phone,
        amount: parseFloat(amount),
        isRecurring,
        status: 'pending' as 'pending' | 'completed',
        createdAt: new Date().toISOString()
      };
      
      console.log('Submitting donation:', donationData);
      
      // Save donation to both Firestore and Firebase Realtime Database
      const result = await saveNewDonation(donationData);
      
      console.log('Donation saved successfully with ID:', result);
      
      // Always ensure we update UI state regardless of success/failure
      setIsProcessing(false);
      setIsSuccess(true);
    } catch (err) {
      setIsProcessing(false);
      setNameError('Failed to process donation. Please try again.');
      console.error('Error saving donation:', err);
    }
  };

  // Handle "Do it later" click
  // handleDoItLater has been removed as the button is no longer needed

  // Render success view
  const renderSuccessView = () => (
    <SuccessContainer>
      <SuccessIcon>
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </SuccessIcon>

      <SuccessTitle>JazakAllahu Khairan!</SuccessTitle>
      <SuccessMessage>Your support is appreciated. May Allah reward you abundantly.</SuccessMessage>

      <InfoBox>
        <InfoBoxTitle onClick={() => setDetailsVisible(!detailsVisible)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Fund Transfer Details
          <span style={{ fontSize: '0.8rem' }}>
            {detailsVisible ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            )}
          </span>
        </InfoBoxTitle>
        
        {detailsVisible && (
          <InfoBoxContent>
            <p>
              <span><strong>UPI ID:</strong> youthekmjila@okicici</span>
              <CopyIcon onClick={() => handleCopy('youthekmjila@okicici', 'UPI ID')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
              </CopyIcon>
            </p>
            <p>
              <span><strong>Gpay:</strong> 9037437401 (Youthekm Jila)</span>
              <CopyIcon onClick={() => handleCopy('9037437401', 'Phone number')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
              </CopyIcon>
            </p>
            <p>
              <span><strong>Bank Account:</strong> YOOSUF ALI K & AMJAD C V</span>
              <CopyIcon onClick={() => handleCopy('YOOSUF ALI K & AMJAD C V', 'Account name')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
              </CopyIcon>
            </p>
            <p>
              <span><strong>A/C No:</strong> 7699652610</span>
              <CopyIcon onClick={() => handleCopy('7699652610', 'Account number')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
              </CopyIcon>
            </p>
            <p>
              <span><strong>IFSC:</strong> IDIB000K726</span>
              <CopyIcon onClick={() => handleCopy('IDIB000K726', 'IFSC code')}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
              </CopyIcon>
            </p>
          </InfoBoxContent>
        )}
        <CopyToast visible={toastVisible}>{toastMessage}</CopyToast>
      </InfoBox>

      <ButtonGroup>
        <PrimaryButton onClick={() => {
          setDetailsVisible(true);
          handleCopyAllDetails();
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
          </svg>
          Copy All Details
        </PrimaryButton>

        <SecondaryButton onClick={onClose}>
          Close
        </SecondaryButton>
      </ButtonGroup>
    </SuccessContainer>
  );

  const renderFormView = () => (
    <ModalForm onSubmit={handleSubmit}>
      <FormGroup>
        <Label htmlFor="name">Name</Label>

          <Input
            type="text"
            id="name"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setName(e.target.value);
              if (e.target.value) setNameError('');
            }}
            placeholder="Enter your name"
            required
            style={{ borderColor: nameError ? '#dc2626' : undefined }}
          />
          {nameError && <InlineErrorMessage>{nameError}</InlineErrorMessage>}

      </FormGroup>
      <FormGroup>
        <Label htmlFor="phone">Phone Number</Label>

          <Input
            type="tel"
            id="phone"
            value={phone}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setPhone(e.target.value);
              if (e.target.value) setPhoneError('');
            }}
            placeholder="Enter your phone number"
            required
            style={{ borderColor: phoneError ? '#dc2626' : undefined }}
          />
          {phoneError && <InlineErrorMessage>{phoneError}</InlineErrorMessage>}

      </FormGroup>
      <FormGroup>
        <Label htmlFor="amount">Donation Amount (in ₹)</Label>

          <AmountContainer style={{ borderColor: amountError ? '#dc2626' : undefined }}>
            <AmountButton
              type="button"
              $active={amount === '500'}
              onClick={() => setAmount('500')}
            >
              ₹500
            </AmountButton>
            <AmountButton
              type="button"
              $active={amount === '1000'}
              onClick={() => setAmount('1000')}
            >
              ₹1,000
            </AmountButton>
            <AmountButton
              type="button"
              $active={amount === '2000'}
              onClick={() => setAmount('2000')}
            >
              ₹2,000
            </AmountButton>
            <AmountButton
              type="button"
              $active={amount === '5000'}
              onClick={() => setAmount('5000')}
            >
              ₹5,000
            </AmountButton>
            <AmountButton
              type="button"
              $active={amount === '10000'}
              onClick={() => setAmount('10000')}
            >
              ₹10,000
            </AmountButton>
            <AmountButton
              type="button"
              $active={!(amount === '500' || amount === '1000' || amount === '2000' || amount === '5000' || amount === '10000')}
              onClick={() => document.getElementById('custom-amount')?.focus()}
              style={{ backgroundColor: '#f9fafb' }}
            >
              Custom
            </AmountButton>
          </AmountContainer>
          <AmountInput
            type="number"
            id="custom-amount"
            value={amount}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setAmount(e.target.value);
              if (e.target.value) setAmountError('');
            }}
            placeholder="Enter custom amount"
            min="1"
            required
            style={{ borderColor: amountError ? '#dc2626' : undefined }}
            onClick={() => {
              const buttons = document.querySelectorAll('button[type="button"]');
              buttons.forEach(btn => {
                if (btn.textContent?.includes('₹')) {
                  btn.setAttribute('aria-pressed', 'false');
                }
              });
            }}
          />
          {amountError && <InlineErrorMessage>{amountError}</InlineErrorMessage>}

      </FormGroup>

      <FormGroup>
        <Label>Frequency</Label>
        <RadioGroup>
          <RadioLabel>
            <RadioInput
              type="radio"
              name="frequency"
              checked={!isRecurring}
              onChange={() => setIsRecurring(false)}
            />
            <span>One-Time</span>
          </RadioLabel>
          <RadioLabel>
            <RadioInput
              type="radio"
              name="frequency"
              checked={isRecurring}
              onChange={() => setIsRecurring(true)}
            />
            <span>Monthly Recurring</span>
          </RadioLabel>
        </RadioGroup>
      </FormGroup>

      <ButtonGroup>
        <PrimaryButton type="submit" disabled={isProcessing}>
          {isProcessing ? (
            <>
              <svg className="animate-spin mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="16" height="16">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Processing...
            </>
          ) : (
            <>
              Confirm Offer
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14"></path>
                <path d="M12 5l7 7-7 7"></path>
              </svg>
            </>
          )}
        </PrimaryButton>
      </ButtonGroup>
    </ModalForm>
  );

  return (
    <ModalOverlay>
      <ModalContainer>
        {/* Desktop header */}
        <ModalHeader>
          <ModalTitle>Support Us</ModalTitle>
          <CloseButton onClick={onClose}>
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </CloseButton>
        </ModalHeader>

        {/* Mobile close button at the top right */}
        <div style={{ 
          display: 'none', 
          position: 'absolute', 
          top: '0.75rem', 
          right: '0.75rem', 
          zIndex: 10 
        }}>
          <CloseButton onClick={onClose} style={{ 
            backgroundColor: 'rgba(255,255,255,0.8)', 
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)' 
          }}>
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </CloseButton>
        </div>

        <ModalBody>
          {isSuccess ? renderSuccessView() : renderFormView()}
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default DonationModal;
